import { render } from "./ClientEventTimelineItem.vue?vue&type=template&id=16723b79"
import script from "./ClientEventTimelineItem.vue?vue&type=script&lang=js"
export * from "./ClientEventTimelineItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__